import moment from "moment"
import { dt } from "src/utils/documentsI18n";
import { useContext, useEffect, useState } from "react"
import { Button, Divider, Icon } from "semantic-ui-react"
import { capitalize, formatMoney, formatMoneyWithCurrency, formatRut } from "src/utils/formatter"
import { DetailGlosa } from "./DetailGlosa"
import CostCenterModal from "../../CostCenterModal"
import { FindDocumentById, RemoveCostCenterFromDocument } from "src/graphql/documents"
import { importAlertState } from "src/redux/actions/alert"
import { useDispatch, useSelector } from "react-redux"
import CustomModal from "src/components/configuracion/components/customModal"
import { CompanyContext, FlowContext } from "src/context"
import { Plans } from "src/utils/plans"
import { GetEERRStructure } from "src/graphql/newEERR"
import FeatherIcon from "feather-icons-react"
import { FindTransactionById } from "src/graphql/conciliacion"
import MatchesTab from "../../documentTypes/MatchesTab"
import NominasTab from "../../documentTypes/NominasTab"


export const BodyDocumentDetail = ({ data, documentCostCenters, reexecuteCostCentersByDocument, selectedTab, processedData }) => {

  const flowContext = useContext(FlowContext)
  const dispatch = useDispatch();
  const [showGlosa, setShowGlosa] = useState(false)
  const [openCostCenterModal, setOpenCostCenterModal] = useState(false)

  const { data: documentData, fetching: documentFetching, error, reexecuteQuery: reexecuteDocument } = FindDocumentById({ ids: processedData.documentInput });
  const { data: transactionData, fetching: transactionFetching, reexecuteQuery: reexecuteTransaction } = FindTransactionById({ ids: processedData.transactionInput })

  const [showOtherTaxes, setShowOtherTaxes] = useState(false)
  const { selectedCompany } = useSelector((state) => state.companyList);
  const companyId = selectedCompany.id;

  const { report } = flowContext || {}
  const categories = [...report?.INCOME || [], ...report?.EXPENSE || []];

  const cashflowAreaName = categories.reduce((acc, el) => {
    if (!el) return acc;
    el.fields.map(item => {
      acc[item.cashflowAreaId] = item.label
    })
    return acc;
  }, {})

  const { data: dataEERR, reexecuteQuery } = GetEERRStructure({ companyId })
  const eerr = dataEERR?.getCompanyEERRStructure

  const findFieldByKey = (report, fieldKey) => {
    for (const category in report) {
      if (!Array.isArray(report[category])) return null;

      const result = report[category].find(item => item.fieldKey === fieldKey);
      if (result) {
        return result.field;
      }
    }
    return null;
  };

  const eerrLabel = data.fieldKey
    ? findFieldByKey(eerr?.report, data.fieldKey)
    : "s/i";
  const removeCostCenterFromDocument = RemoveCostCenterFromDocument();

  const [modalData, setModalData] = useState({ open: false, action: '', centerId: null, centerName: '' });

  const showEerr = (selectedCompany && selectedCompany?.plan
    && (selectedCompany?.plan.includes(Plans.smartcfo))
    && selectedCompany?.plan.length == 1);

  const factoring = data?.meta?.factoring?.cedido
  const glosaExist =
    data.documentType == "TAX_DOCUMENT" && data.meta?.description && data.meta.description.length > 0
    || data.documentType == "OBLIGATION" && data.meta?.detail && data.meta.detail.length > 0

  const value = {
    description: data.documentType == "TAX_DOCUMENT" ? data.meta?.description : data.meta?.detail,
    detail: data.documentType == "TAX_DOCUMENT" ? data.meta?.summary : data?.meta?.typeLabel,
    documentNumber: data.meta?.documentId || data.meta?.number || '-',
    amount: data?.amount,
    emition: data?.documentDate,
  }

  const handleDelete = (centerId, centerName) => {

    setModalData({
      open: true,
      action: 'delete',
      centerId,
      centerName
    });
  };


  async function removeCostCenter() {
    try {
      await removeCostCenterFromDocument.executeMutation({
        companyId: data.companyId,
        documentId: data?.id|| data?._id,
        costCenterId: modalData.centerId
      })

      reexecuteCostCentersByDocument({ requestPolicy: 'network-only' });

      dispatch(
        importAlertState({
          content: dt('costCenter.deletedOk'),
          state: "success",
          duration: 5,
        })
      );

      closeModal();
    } catch (error) {
      dispatch(
        importAlertState({
          content: dt('costCenter.deleteFailed'),
          state: "error",
          duration: 5,
        })
      );
      closeModal();
    }
  }

  const closeModal = () => {
    setModalData({ open: false, action: '', centerId: null, centerName: '' });
  };

  const totalOtherTaxes = data?.meta?.otherTaxes?.reduce((acc, tax) => acc + tax.value, 0);

  const BodyOtherTaxes = () => {
    return (
      <>
        {data.meta.otherTaxes.map((tax, index) => (
          <div
            key={index}
            className="tw-h-[36px] tw-ps-[12px] tw-py-[9px] tw-flex tw-justify-between"
          >
            <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{tax.code} - {tax.name}</p>
            <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">${formatMoney(tax.value)}</p>
          </div>
        ))}
      </>
    );
  };

  const pdfUrl = data.meta?.download?.pdf?.url || data.meta?.download?.html?.url
  const xmlUrl = data.meta?.download?.xml?.url

  const handleDownload = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    }
  };

  const handleDownloadXML = () => {
    if (xmlUrl) {
      window.open(xmlUrl, "_blank");
    }
  };


  const nominaData = data?.meta?.nominaStatus?.inNominaProcess


  const classifyMatches = (data, documents, transactions) => {

    const inMatchIds = data?.meta?.matchs?.inMatch?.map(item => item.id) || [];
    const settleIds = data?.meta?.matchs?.inMatch?.map(item => item.settleId).filter(id => id != null) || [];
    const outMatchIds = data?.meta?.matchs?.outMatch?.map(item => item.id) || [];

    const documentInMatches = documents?.filter(doc =>
      inMatchIds.includes(doc._id || doc.id)
    ) || [];

    const settleInMatches = data?.meta?.matchs?.inMatch?.filter(data =>
      settleIds.includes(data.settleId)
    ) || [];

    const documentOutMatches = documents?.filter(doc =>
      outMatchIds.includes(doc._id || doc.id)
    ) || [];

    const transactionInMatches = transactions?.filter(trans =>
      inMatchIds.includes(trans.id)
    ) || [];

    const transactionOutMatches = transactions?.filter(trans =>
      outMatchIds.includes(trans.id)
    ) || [];

    return {
      documentInMatches,
      transactionInMatches,
      documentOutMatches,
      transactionOutMatches,
      settleInMatches
    };
  };

  const {
    documentInMatches,
    transactionInMatches,
    documentOutMatches,
    transactionOutMatches,
    settleInMatches
  } = classifyMatches(
    data,
    documentData?.findDocumentsById || [],
    transactionData?.findTransactionsById || []
  );

  const calculateTotals = () => {
    let totalInMatch = 0;
    let totalOutMatch = 0;

    documentInMatches.forEach(doc => {
      const matches = doc.meta?.matchs;
      if (!matches) return;

      if (data?.documentType === 'TAX_DOCUMENT' && doc.documentType === 'OBLIGATION') {
        matches.outMatch?.forEach(match => {
          if (match.id === data.id) {
            totalInMatch += match.matchedAmount || match.amount;
          }
        });
      } else {
        matches.inMatch?.forEach(match => {
          if (match.id === data.id) {
            totalInMatch += match.matchedAmount || match.amount;
          }
        });
      }
    });

    transactionInMatches.forEach(trans => {
      const matches = trans?.matchs;
      if (!matches) return;
      matches.forEach(match => {
        if (match.docId === data.id) {
          totalInMatch += match.matchedAmount || match.amount;
        }
      });
    });

    if (settleInMatches.length > 0) {
      settleInMatches.forEach(settle => {
        totalInMatch += settle?.amount
      })
    }

    documentOutMatches.forEach(doc => {
      const matches = doc.meta?.matchs;
      if (!matches) return;

      if (data?.documentType === 'OBLIGATION' && doc.documentType === 'TAX_DOCUMENT') {
        matches.inMatch?.forEach(match => {
          if (match.id === data.id) {
            totalOutMatch += match.matchedAmount || match.amount;
          }
        });
      } else {
        matches.outMatch?.forEach(match => {
          if (match.id === data.id) {
            totalOutMatch += match.matchedAmount || match.amount;
          }
        });

      }
    });

    transactionOutMatches.forEach(trans => {
      const matches = trans?.matchs;
      if (!matches) return;
      matches.forEach(match => {
        if (match.docId === data.id) {
          totalOutMatch += match.matchedAmount || match.amount;
        }
      });
    });

    return { totalInMatch, totalOutMatch };
  };

  const { totalInMatch, totalOutMatch } = calculateTotals();


  return (
    <>
      <div className="tw-px-5">
        <div className="tw-grid tw-gap-[18px] tw-overflow-hidden tw-pb-4">
          {selectedTab === "Detalles" ?
            (
              <>
                <div className="">
                  <div className="tw-max-h-[39px] tw-flex tw-justify-between">
                    <div>
                      <h2 className="!tw-m-0 tw-text-[15px] tw-font-semibold tw-text-gray-700">{data?.meta?.summary || data?.meta?.typeLabel || "-"} ${formatMoney(data?.meta?.originalAmount) || "0"}</h2>
                      <p className="tw-text-[12px] !tw-m-0 tw-text-gray-600">{moment(data?.documentDate).format("DD/MM/YYYY")}</p>
                    </div>
                    <div className="tw-flex tw-gap-4">
                      <div
                        className={`${pdfUrl ? '' : 'tw-opacity-45'}`}
                      >
                        <button
                          className="tw-w-[82px] tw-h-[36px] tw-rounded tw-border-solid tw-border-[1px] tw-border-[#0099FF] tw-bg-white tw-py-1 tw-ps-3 tw-pe-4"
                          onClick={handleDownload}
                          disabled={!pdfUrl}
                        >
                          <div className="tw-flex tw-justify-between tw-items-center tw-text-[#0099FF]">
                            <FeatherIcon icon={`${pdfUrl ? 'download' : 'slash'}`} size={'16px'} />
                            <p className="tw-font-sans tw-font-medium tw-text-[16px]">PDF</p>
                          </div>
                        </button>
                      </div>
                      <div
                        className={`${xmlUrl ? '' : 'tw-opacity-45'}`}
                      >
                        <button
                          className="tw-w-[82px] tw-h-[36px] tw-rounded tw-border-solid tw-border-[1px] tw-border-[#0099FF] tw-bg-white tw-py-1 tw-ps-3 tw-pe-4"
                          onClick={handleDownloadXML}
                          disabled={!xmlUrl}
                        >
                          <div className="tw-flex tw-justify-between tw-items-center tw-text-[#0099FF]">
                            <FeatherIcon icon={`${xmlUrl ? 'download' : 'slash'}`} size={'16px'} />
                            <p className="tw-font-sans tw-font-medium tw-text-[16px]">XML</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="tw-min-h-[231px] tw-mt-4">
                    <div className="tw-grid tw-gap-[12px] tw-grid-cols">
                      {/* Titulo */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.titleField')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.summary || data?.meta?.typeLabel || "-"}</p>
                        </div>
                      </div>
                      {/* Numero / Folio */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.numberFolio')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.documentId || data?.meta?.number || "-"}</p>
                        </div>
                      </div>
                      {/* Estado de recepcion */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.receptionStatus')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.isReceived ? "Recibida" : "Emitida"}</p>
                        </div>
                      </div>
                      {/* Fecha Emision */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.issueDateTitle')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{moment(data?.documentDate).format("DD/MM/YYYY")}</p>
                        </div>
                      </div>
                      {/* Area flujo de caja */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.cashflowArea')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{cashflowAreaName[data?.cashflowAreaId] || 's/i'}</p>
                        </div>
                      </div>
                      {/* Area flujo de caja */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.eerrArea')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[18px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{eerrLabel}</p>
                        </div>
                      </div>
                      {/* Emisor */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">Emisor</p>
                        </div>
                        <div className="tw-w-[438px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.issuerName || "-"}</p>
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{formatRut(data?.meta?.issuerId) || "-"}</p>
                        </div>
                      </div>
                      {/* Receptor */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">Receptor</p>
                        </div>
                        <div className="tw-w-[438px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.receiverName || "-"}</p>
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{formatRut(data?.meta?.receiverId) || "-"}</p>
                        </div>
                      </div>
                      {/* Estado */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[21px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">Estado</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[21px] tw-flex tw-gap-[6px]">
                          {
                            data?.meta?.isPaid ?
                              <div className="tw-h-[21px] tw-pt-[2px] tw-px-[9px] tw-bg-green-50 tw-rounded-[6px]">
                                <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-green-600">Pagada</p>
                              </div>
                              :
                              <div className="tw-h-[21px] tw-pt-[2px] tw-px-[9px] tw-bg-yellow-50 tw-rounded-[6px]">
                                <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-yellow-600">{data?.meta?.isReceived === true ? dt('detail.pendingPaymentShort') : dt('detail.pendingCollectionShort')}</p>
                              </div>
                          }
                          {
                            factoring &&
                            <div className="tw-w-[90px] tw-h-[21px] tw-py-[3px] tw-px-[9px] tw-bg-violet-50 tw-rounded-[6px] tw-flex tw-gap-[6px] tw-items-center">
                              <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-violet-600">Factoring</p>
                              <Icon
                                name="info circle"
                                className="tw-text-violet-600"
                              />
                            </div>
                          }
                        </div>
                      </div>
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-h-[21px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">Monto {data?.meta?.isReceived ? 'por pagar' : 'por cobrar'}</p>
                        </div>
                        <div className="tw-w-[438px] tw-h-[21px] tw-flex tw-gap-[6px]">
                          {
                            data?.meta?.remaining > 0 ?
                              <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{formatMoneyWithCurrency(data?.meta?.remaining)}</p>
                              :
                              <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{formatMoneyWithCurrency(0)}</p>
                          }
                        </div>
                      </div>
                      {/* Doc Ref */}
                      {/* {data.meta?.refDocuments && data.meta?.refDocuments?.length > 0 && data.meta?.documentCode != 0 && */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.referredDocument')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{dt('detail.documentCodeLabel')}: <b>{data?.meta?.refDocuments ? data.meta?.refDocuments[0]?.documentCode || "-" : "-"}</b></p>
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">Folio: <b>{data?.meta?.refDocuments ? data.meta?.refDocuments[0]?.documentId || '-' : "-"}</b></p>
                        </div>
                      </div>
                      {/* } */}
                      {/* Bar Code */}
                      {/* {data.meta?.barCode && */}
                      <div className="tw-flex">
                        <div className="tw-w-[240px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.uniqueCode')}</p>
                        </div>
                        <div className="tw-w-[438px] tw-min-h-[33px]">
                          <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-gray-700">{data?.meta?.barCode || 's/i'}</p>
                        </div>
                      </div>
                      {/* } */}
                    </div>
                  </div>
                  {/* Descripcion */}
                  <div className="tw-border-solid tw-border-[1px] tw-border-gray-200 tw-rounded-[3px] tw-mt-4">
                    <div className="tw-bg-gray-50 tw-h-[36px] borderHeaderModalDoc">
                      <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                        <p className="tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.descriptionField')}</p>
                        <p className="tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('detail.amountField')}</p>
                      </div>
                    </div>
                    {/* Monto neto */}
                    <div className="tw-h-[36px]">
                      <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{dt('detail.netAmountField')}</p>
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">${formatMoney(data?.meta?.netAmount) || "0"}</p>
                      </div>
                    </div>
                    {/* Monto iva */}
                    <div className="tw-h-[36px]">
                      <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">Monto IVA ({(data?.meta?.taxRate * 100).toFixed(1)}%)</p>
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">${formatMoney(data?.meta?.taxAmount || 0) || "0"}</p>
                      </div>
                    </div>
                    {/* Otros impuestos */}
                    {
                      data?.meta?.otherTaxes &&
                      <div className="tw-grid">
                        <div
                          className="tw-px-[12px] tw-pt-[9px] tw-flex tw-justify-between tw-cursor-pointer"
                          onClick={() => setShowOtherTaxes(prevState => !prevState)}
                        >
                          <div className="tw-flex tw-items-center tw-pb-[9px]">
                            {
                              showOtherTaxes ?
                                <Icon
                                  name="angle up"
                                />
                                :
                                <Icon
                                  name="angle down"
                                />
                            }
                            <p className="tw-text-[12px] tw-font-normal tw-text-gray-700 tw-mb-[6px]">Otros impuestos</p>
                          </div>
                          <div>
                            <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">${formatMoney(totalOtherTaxes || 0) || "0"}</p>
                          </div>
                        </div>
                        {
                          showOtherTaxes &&
                          <div className="tw-px-[12px] tw-bg-gray-50">
                            <BodyOtherTaxes />
                          </div>
                        }
                      </div>
                    }
                    {/* Monto bruto */}
                    <div className="tw-h-[36px]">
                      <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{dt('detail.grossAmountField')}</p>
                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{formatMoneyWithCurrency(data?.meta?.summary == 'Boleta de Honorarios' ? data.meta?.netAmount + data?.meta?.taxAmount : data.meta?.originalAmount, data?.currencyType || 'CLP') || "0"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
            : selectedTab === "Glosa" ?
              (
                <>
                  <div className="">
                    <div className="tw-grid tw-gap-[12px]">
                      <h4 className="!tw-m-0 tw-text-[15px] tw-font-semibold tw-text-gray-700">Glosa</h4>
                      {
                        glosaExist ?
                          <>
                            <div className="tw-gap-[6px] tw-border-solid tw-border-[1px] tw-border-gray-300 tw-rounded-[3px] tw-cursor-pointer"
                              onClick={() => setShowGlosa(prevState => !prevState)}
                            >
                              <div
                                className="tw-bg-gray-50 tw-h-[42px] tw-p-[12px] tw-flex tw-justify-between"
                                style={showGlosa ? { borderBottom: 'solid 1px #d1d5db' } : {}}
                              >
                                <p className="tw-text-[12px] tw-font-semibold tw-text-gray-700">{dt('detail.glosaDetail')}</p>
                                {
                                  showGlosa ?

                                    <Icon
                                      name='angle up'
                                      size="lage"
                                    />
                                    :
                                    <Icon
                                      name='angle down'
                                      size="lage"
                                    />
                                }
                              </div>
                              {
                                showGlosa &&
                                <div className="">
                                  <DetailGlosa
                                    value={value}
                                  />
                                </div>
                              }
                            </div>

                          </>
                          :
                          <div className="tw-py-[3px] tw-px-[9px] tw-rounded-[6px] tw-h-[21px] tw-w-[91px] tw-bg-gray-100">
                            <p className="tw-text-[10.5px] tw-font-medium tw-text-gray-600">No disponible</p>
                          </div>
                      }
                    </div>
                  </div>
                </>
              )
              : selectedTab === "Matchs" ?
                (
                  <>
                    <MatchesTab
                      data={data}
                      matchesData={data.meta?.matchs}
                    />
                  </>
                )
                : selectedTab === "Centro de Costos" ?
                  (
                    <>
                      {
                        !showEerr &&
                        <div className="tw-flex-row tw-gap-[12px]">
                          {/* Centro de Costos */}
                          <h4 className="!tw-m-0 tw-text-[15px] tw-font-semibold tw-text-gray-700">{dt('costCenter.sectionTitle')}</h4>
                          <div className="tw-border-solid tw-border-[1px] tw-border-gray-200 tw-rounded-[3px] tw-mt-4">
                            <div className="tw-bg-gray-50 tw-h-[36px] borderHeaderModalDoc">
                              <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                                <p className="tw-text-[12px] tw-font-medium tw-text-gray-700">{dt('costCenter.colName')}</p>
                                <div className="tw-flex tw-justify-end tw-pe-[10px]">
                                  <p className="tw-text-[12px] tw-font-medium tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">{dt('costCenter.colGross')}</p>
                                  <p className="tw-text-[12px] tw-font-medium tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">{dt('costCenter.colNet')}</p>
                                  <p className="tw-text-[12px] tw-font-medium tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">Acciones</p>
                                </div>
                              </div>
                            </div>
                            {/* Centro de costos asignados */}
                            {
                              documentCostCenters.length > 0 ?
                                documentCostCenters.map((costCenter, index) => (
                                  <div className="tw-h-[36px]">
                                    <div key={index} className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                                      <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{capitalize(costCenter.label)}</p>
                                      <div className="tw-flex">
                                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">{formatMoneyWithCurrency(costCenter.originalAmount)}</p>
                                        <p className="tw-text-[12px] tw-font-normal tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">{formatMoneyWithCurrency(costCenter.amount)}</p>
                                        <div className="tw-w-[125px] tw-flex tw-justify-end">
                                          <div
                                            className="tw-h-[21px] tw-pt-[2px] tw-px-[9px] tw-bg-red-50 tw-rounded-[6px] tw-cursor-pointer"
                                            onClick={() => handleDelete(costCenter.id, costCenter.label)}
                                          >
                                            <p className="!tw-m-0 tw-text-[12px] tw-font-normal tw-text-red-600 tw-shadow-md ">{dt('costCenter.delete')}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                                :
                                <div className="tw-h-[36px]">
                                  <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                                    <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{dt('costCenter.noneAssigned')}</p>
                                  </div>
                                </div>
                            }
                            <div className="tw-flex tw-px-[9px] tw-pb-[9px] tw-pt-[18px] tw-justify-center">
                              <div className="tw-flex tw-py-[3px] tw-px-[9px] tw-rounded-[6px] tw-h-[30px] tw-bg-gray-100 tw-shadow-lg tw-cursor-pointer tw-items-center tw-border-solid tw-border-[1px] tw-border-gray-200"
                                onClick={setOpenCostCenterModal}
                              >
                                <p className="tw-text-[10.5px] tw-font-medium tw-text-gray-600">{dt('costCenter.title')}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </>
                  )
                  : selectedTab === "Nóminas" &&
                  (
                    <>
                      <NominasTab
                        data={data}
                      />
                    </>
                  )
          }
        </div>
      </div>
      <CostCenterModal
        isMassive={false}
        selectedAmount={data?.meta?.originalAmount}
        companyId={data?.companyId}
        selectedDocumentsIds={[data?._id || data?.id]}
        documentCostCenters={documentCostCenters}
        reexecuteCostCentersByDocument={reexecuteCostCentersByDocument}
        isVisible={openCostCenterModal}
        setIsVisible={setOpenCostCenterModal}
      />
      <CustomModal
        open={modalData.open}
        onClose={closeModal}
        title={
          modalData.action === 'edit'
            ? dt('costCenter.catalog.editTitle')
            : modalData.action === 'create'
              ? dt('costCenter.catalog.createTitle')
              : dt('costCenter.deleteTitle')
        }
        content={
          <p>{dt('costCenter.deleteConfirm')} <strong>{modalData.centerName}</strong>?</p>
        }
        onConfirm={removeCostCenter}
        confirmLabel={dt('costCenter.delete')}
      />
    </>
  )
}